import React from "react";
import Link from "gatsby-link";
import GraphenePython from "./graphene-python.svg";
import GrapheneJS from "./graphene-js.svg";
import Quiver from "./quiver.svg";

const IndexPage = () => (
  <div>
    <div className="hero container">
      <h1>
        <b>Graphene</b> Family
      </h1>
      <p>
        Each product addresses a focused concern for the technical and
        organizational challenges of building GraphQL infrastructure.
      </p>
    </div>

    <div className="products container">
      <a href="http://graphene-python.org/">
        <GraphenePython />
        <span className="tagline">
          The popular framework for building GraphQL APIs in Python.
        </span>
      </a>
      <a href="http://graphene-js.org/">
        <GrapheneJS />
        <span className="tagline">
          The popular framework now have a  new companion in the most
          used language for frontend: JS.{" "}
        </span>
      </a>
      <a href="http://graphql-quiver.com/">
        <Quiver />
        <span className="tagline">
          Next Generation GraphQL Engine that scales with your company.{" "}
        </span>
      </a>
    </div>
    <style jsx>{`
      h1 {
        /* Graphene Family: */
        font-size: 41px;
        font-weight: 300;
        color: #ffffff;
        letter-spacing: -0.75px;
      }
      h1 b {
        font-weight: 600;
      }
      .hero {
        padding-top: 60px;
        max-width: 520px;
        margin: 0 auto;
        text-align: center;
        font-weight: 300;
      }
      .hero p {
        /* Each product address: */
        font-family: "Open Sans";
        font-size: 24px;
        color: #ffffff;
        letter-spacing: -0.44px;
      }
      .products {
        margin-top: 100px;
        text-align: center;
        margin-bottom: 20px;
      }
      .products a {
        text-align: left;
        vertical-align: top;
        width: 260px;
        margin: 30px;
        position: relative;
        display: inline-block;
      }
      .products .tagline {
        display: block;
        /* The popular framewor: */
        font-family: "Open Sans";
        font-weight: 400;
        font-size: 16px;
        color: #838995;
        letter-spacing: -0.29px;
      }
    `}</style>
  </div>
);

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js